<template>
    <div id="EditWorkflow">
        <div class="wrapper">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/tasks')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <WorkflowIcon />
                    </div>
                    <div class="name">{{ $t("task.workflow") }}: {{ selectedWorkflow.title }}</div>
                </div>
                <div class="right">
                    <SupsisButton
                        style="cursor:pointer"
                        @click="$router.push({ path: '/tasks', query: { type: 'kanban', workflow: selectedWorkflow._id } })">
                        <div style="display: flex;justify-content: center;align-items: center;gap: 5px;">
                            <span class="material-icons"> view_kanban </span>
                            <div style="font-weight: bold;">{{ $t("auto.board") }}</div>
                        </div>

                    </SupsisButton>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <SidebarChild
                        :items="menuItems"
                        :selected-item="type"
                        :focusActive="true"
                        @selected="(i) => (type = i.key)"
                    />
                </div>
                <div class="page-content">
                    <div v-if="type === 'detail'">
                        <div class="header">
                            <div class="title">{{ $t("task.workflowDetail") }}</div>
                        </div>
                        <div style="padding: 20px 50px 5px 50px">
                            <WorkflowForm :details="workflowDetails" @update-form="updateForm" :editMode="true" />
                        </div>
                        <div style="display: flex; justify-content: end; cursor: pointer; margin-right: 30px">
                            <SupsisButton style="margin-top: 10px" @click="saveDetail">{{ $t("auto.save") }} </SupsisButton>
                        </div>
                    </div>
                    <div v-if="type === 'permission'">
                        <div class="header">
                            <div class="title">{{ $t("task.workflowPerm") }}</div>
                        </div>
                        <div style="padding: 20px 50px 5px 50px">
                            <PermissionWorkflow :details="workflowDetails" @update-form="updatePermissions" />
                        </div>
                    </div>
                    <div v-if="type === 'visibility'">
                        <div style="padding: 20px 50px 5px 50px">
                            <VisibilityWorkFlow :details="workflowDetails" @update-form="updateForm" />
                        </div>
                        <div style="display: flex; justify-content: end; cursor: pointer; margin-right: 30px">
                            <SupsisButton style="margin-top: 10px" @click="saveDetail"
                                >{{ $t("message.save") }}
                            </SupsisButton>
                        </div>
                    </div>
                    <div v-if="type === 'done'">
                        <div class="header">
                            <div class="title">{{ $t("message.completedTasks") }}</div>
                        </div>
                        <DoneTask :details="workflowDetails" />
                    </div>
                    <div  v-if="type === 'doneTaskSettings'">
                        <DoneTaskSettings :details="workflowDetails" />
                    </div>
                    <div v-if="type === 'task-module-rules'">
                        <TaskModuleRules :workflow-id="selectedWorkflow._id" />
                    </div>
                    <div v-if="type === 'checklist-templates'">
                        <ChecklistTemplates :workflow-id="selectedWorkflow._id" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppBreadCrumb from "../common/AppBreadCrumb.vue";
import IconButton from "../../views/Pages/Settings/components/IconButton.vue";
import WorkflowIcon from "../../views/Pages/Chatbot/pages/integrations/svg/WorkflowIcon.vue";
import SidebarChild from "../Sidebar/SidebarChild.vue";
import { getOrUpdateFilters } from "../../utils/persistenceStorage";
import { mapActions, mapState } from "vuex";
import WorkflowForm from "./WorkflowForm.vue";
import SupsisButton from "../common/SupsisButtonOld.vue";
import VisibilityWorkFlow from "./VisibilityWorkFlow.vue";
import PermissionWorkflow from "./PermissionWorkflow.vue";
import DoneTask from "./DoneTask.vue";
import DoneTaskSettings from "./DoneTaskSettings.vue";
import TaskModuleRules from "../../views/Pages/Settings/pages/task-module-rules/TaskModuleRules.vue";
import ChecklistTemplates from "./ChecklistTemplates.vue";

const filters = getOrUpdateFilters("workflowDetail");
export default {
    name: "EditWorkflow",
    components: {
        SidebarChild,
        IconButton,
        AppBreadCrumb,
        WorkflowIcon,
        WorkflowForm,
        SupsisButton,
        VisibilityWorkFlow,
        PermissionWorkflow,
        DoneTask,
        DoneTaskSettings,
        TaskModuleRules,
        ChecklistTemplates
    },
    data() {
        return {
            type: filters.type || "detail",
            form: {},
            menuItems: [
                {
                    enabled: true,
                    key: "detail",
                    label: this.$t("task.detail"),
                    icon: {
                        type: "material-icons",
                        name: "info",
                    },
                },
                {
                    enabled: true,
                    key: "permission",
                    label: this.$t("task.perm"),
                    icon: {
                        type: "material-icons",
                        name: "key",
                    },
                },
                {
                    enabled: true,
                    key: "visibility",
                    label: this.$t("multi_whatsapp_api.visibility"),
                    icon: {
                        type: "material-icons",
                        name: "visibility",
                    },
                },
                {
                    enabled: true,
                    key: "doneTaskSettings",
                    label: "Task Kapatma Ayarları",
                    icon: {
                        type: "material-icons",
                        name: "settings",
                    },
                },
                {
                    enabled: true,
                    key: "task-module-rules",
                    label: "Görev Modülü Kuralları",
                    icon: {
                        type: "material-icons",
                        name: "account_tree",
                    },
                },
                {
                    enabled: true,
                    key: "checklist-templates",
                    label: "Checklist Şablonları",
                    icon: {
                        type: "material-icons",
                        name: "checklist",
                    },
                },
                // {
                //     enabled: true,
                //     key: "done",
                //     label: "Tamamlanmış Görevler",
                //     icon: {
                //         type: "material-icons",
                //         name: "edit_attributes",
                //     },
                // },
            ],
        };
    },
    computed: {
        ...mapState({
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        selectedWorkflow() {
            return this.workflows[this.$route.params.id];
        },
        workflowDetails() {
            return { workflowId: this.selectedWorkflow?._id };
        },
    },
    methods: {
        ...mapActions({
            updateWorkflow: "tasks/updateWorkflow",
        }),
        updateForm(form) {
            this.form = form;
        },
        updatePermissions(updatedPermissions) {
            this.form.permissions = updatedPermissions;
            this.saveDetail();
        },
        saveDetail() {
            this.updateWorkflow({
                workflowId: this.selectedWorkflow._id,
                params: this.form,
            }).then(() => {
                this.$notification.success({
                    message: this.$t("task.workflowUpdateMs"),
                    description: this.$t("task.workflowUpdateMs"),
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
#EditWorkflow {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    background: #737981;
                    padding: 10px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }
    }

    .channel-content {
        display: flex;
        height: 100%;

        .left {
            height: 100%;

            .channel-menu {
                width: 100%;
            }
        }

        .page-content {
            width: 100%;
            height: 100%;
        }
    }

    .header {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            padding: 10px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
